import { render, staticRenderFns } from "./pageLoading.vue?vue&type=template&id=3ef06bc9&scoped=true"
import script from "./pageLoading.vue?vue&type=script&lang=js"
export * from "./pageLoading.vue?vue&type=script&lang=js"
import style0 from "./pageLoading.vue?vue&type=style&index=0&id=3ef06bc9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef06bc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/1/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ef06bc9')) {
      api.createRecord('3ef06bc9', component.options)
    } else {
      api.reload('3ef06bc9', component.options)
    }
    module.hot.accept("./pageLoading.vue?vue&type=template&id=3ef06bc9&scoped=true", function () {
      api.rerender('3ef06bc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/static/loading/pageLoading.vue"
export default component.exports